// extracted by mini-css-extract-plugin
export default {"quick-replies":"RBJQu","quick-replies__list":"vAY95"};